app.controller('CIFDashboard-CTRL', ['$scope', '$http', '$window','$uibModal', '$timeout', '$q', 'appFactory',
    function ($scope, $http, $window, $uibModal, $timeout, $q, appFactory) {

    $scope.CIFInvestor = {}
    $scope.page = '';

    $scope.submitSales = function () {
        $scope.openModalSales();
    }

    $scope.datanasabah = function () {

        $window.location.href = "#/profile";
    }

    $scope.stepClass = ['', 'blur', 'blur', 'blur', 'blur'];

    $scope.active = "active current";

    $scope.imgMale = "";
    $scope.imgDoc = "";
    $scope.imgFemale = "";
    $scope.chkquestionfatca = 2;
    $scope.RequestClient = false;
    $scope.RequestClientApprove = false;

    $scope.openModalSales = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: 'myModalContentSales.html',
            controller: 'ModalDashboardInstanceCtrl',
            size: 'md',
            resolve: {
                items: function () {
                    return $scope.modalMessage;
                }
            }
        });
    };

    var allPromise = $q.all([

          $http({
              method: 'GET',
              url: '/service/client.svc/getCIFDetail',
              cache: true,
          }).then(function (data) {
              $scope.CIFDetail = data.data.d;
              $scope.CIFInvestor.QuestionRDN = data.data.d.QuestionRDN;
              $scope.CIFInvestor.WebCIFNID = data.data.d.AutoNID;
              $scope.CIFInvestor.CIFNID = data.data.d.CIFNID;
          }, function (error) { }),

        $scope.retrieveSessions()
    ]);

    allPromise.then(function () {

        appFactory.getData(`/service/client.svc/getCIFDetail`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;


                    if ($scope.CIFInvestor.State1)
                        $scope.stepClass[1] = "active current";

                    if ($scope.CIFInvestor.State2 && $scope.CIFInvestor.ChangeNID != 0)
                        $scope.stepClass[2] = "active current";

                    if ($scope.CIFInvestor.State3 && $scope.CIFInvestor.ChangeNID != 0)
                        $scope.stepClass[3] = "active current";

                    if ($scope.CIFInvestor.State4 && $scope.CIFInvestor.ChangeNID != 0)
                        $scope.stepClass[4] = "active current";

                    if ($scope.CIFInvestor.IsFinished == 1)
                        $scope.page = 'finished'

                    if ($scope.CIFInvestor.IsRevised == 1)
                        $scope.page = 'revised'

                    if ($scope.CIFInvestor.StatusRequestClient == true) {
                        $scope.RequestClient = true;
                    }
                    else {
                        $scope.RequestClient = false;
                        $scope.RequestClientApprove = true;
                    }
                }
            }
        })
    });

    $scope.login = function () {
        $window.location.href = "#/cif/data-pribadi";
    }
    }]);

app.controller('ModalDashboardInstanceCtrl', ['$scope', '$window', '$rootScope', '$uibModalInstance', '$uibModal', '$q', 'appFactory', 'deviceDetector', 'items', '$http',
    function ($scope, $window, $rootScope, $uibModalInstance, $uibModal, $q, appFactory, deviceDetector, items, $http) {

    $scope.CIFInvestor = {
        //Sales: '',
        CIFNID: '',
        WebCIFNID: '',
        QuestionRDN: '',
        Void: '',

    }

    $scope.rdn = true;

    $scope.SalesSelected = '';
    $scope.ListSales = [];

    $scope.selectSales = function (item, model, label, event) {
        if (item.SalesPersonNID) {
            $scope.CIFInvestor.Sales = item.SalesPersonNID;
            $scope.SalesSelected = item;
        }

    };

    $scope.RemiserSelected = '';

    $scope.selectRemiser = function (item, model, label, event) {
        if (item.NID) {
            $scope.CIFInvestor.NID = item.NID;
            $scope.RemiserSelected = item;
        }

    };

    $scope.items = items;
    console.log("items", items)
    console.log("CIFInvestor", $scope.CIFInvestor)
   
    $scope.ok = function () {
        $uibModalInstance.close($scope.item);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.showAgreement = function (number) {

        let htmlName = 'template/Marginagereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'MarginAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {

                agreementNumber: function () {

                    return number;
                }
            }
        });

        modalInstance.result.then(function (response, agree) {

            if (response == 'accept') {

                if (number == 1) {

                    $scope.agree1 = true;
                    $scope.disclaimerClose = true;
                }


                if ($scope.disclaimerClose == true);
            }
        }, function () { });
    };
   

    var allPromise = $q.all([
       $http({
           method: 'GET',
           url: '/service/client.svc/getRemiserList',
           cache: true,
       }).then(function (data) {
           $scope.ListRemiser = data.data.d;
       }, function (error) { }),

       $http({
           method: 'GET',
           url: '/service/client.svc/getCIFDetail',
           cache: true,
       }).then(function (data) {
           $scope.CIFDetail = data.data.d;
           $scope.CIFInvestor.QuestionRDN = data.data.d.QuestionRDN;
           $scope.CIFInvestor.WebCIFNID = data.data.d.AutoNID;
           $scope.CIFInvestor.CIFNID = data.data.d.CIFNID;
           $scope.CIFInvestor.Void = data.data.d.Void;
           if ($scope.CIFInvestor.QuestionRDN == 1) {
               $scope.RDNBCA = true;
               $scope.RDNPERMATA = false;
               $scope.CIFInvestor.QuestionRDN = '1';
           }
           if ($scope.CIFInvestor.QuestionRDN == 2) {
               $scope.RDNPERMATA = true;
               $scope.RDNBCA = false;
               $scope.CIFInvestor.QuestionRDN = '2';
           }

           if ($scope.CIFInvestor.StatusRequestClient == true) {
               $scope.RequestClient = true;
           }
           else {
               $scope.RequestClient = false;
               $scope.RequestClientApprove = true;
           }
       }, function (error) { }),

       $http({
           method: 'GET',
           url: '/service/client.svc/GetCIFSales',
           cache: true,
       }).then(function (data) {
           $scope.ListSales = data.data.d;
       }, function (error) { }),

    ]);

    $scope.submitRemiserOK = function () {
        $scope.CIFInvestor.CIFNID = $scope.CIFInvestor.CIFNID;
        $scope.CIFInvestor.QuestionRDN = $scope.CIFInvestor.QuestionRDN;
        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah Data Anda sudah sesuai ?")
        .then((result) => {
            if (result.value) {
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveRemiser',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {
                    if (data.data.d.result) {
                        Swal.fire('Success', 'Permintaan Pembukaan Rekening Baru', 'success').then(function () {
                            Swal.close();
                            $window.location.href = "#/dashboard";
                            $window.location.reload();
                        });
                    }
                    else {
                        Swal.fire('Error', data.data.d.result.message, 'error');
                    }
                }, function (error) {
                    Swal.fire('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }



    }]);

app.controller('MarginAgreementCtrl', ['$scope', '$uibModalInstance', 'agreementNumber', '$q', 'appFactory',
    function ($scope, $uibModalInstance, agreementNumber, $q, appFactory) {

        $scope.agreementNumber = agreementNumber;

        $scope.accept = function () {

            $uibModalInstance.close('accept', $scope.agreementNumber);
        };


        var allPromise = $q.all([


        ]);

        allPromise.then(function () {

        });

        $scope.cancel = function () {

            $uibModalInstance.dismiss('cancel', $scope.agreementNumber);
        };
    }]);